
import { environment } from 'src/environments/environment';
import { BackendConstants } from '../backend/backend.constants';



let PACKAGE_LEADS_ = 'PUBLIC_LEADS_DEV';

if (environment.production) {
  PACKAGE_LEADS_ = 'PUBLIC_LEADS';
}

export const URL_ENDPOINT_PORTABILITY = BackendConstants.URL_ENDPOINT_BACKEND + "/portability";
export const URL_ENDPOINT_SECURE_PORTABILITY = BackendConstants.URL_ENDPOINT_BACKEND_SECURE + "/portability";

export const TOKEN_PORTABILITY = 'fe7db1f7-7a6b-4a6e-8284-e1ac33854b56';
export const PACKAGE_LEADS = PACKAGE_LEADS_;
export const SECONDS_TIMER_NIP = 60 * 5;

export const PORT_STATUS_VECTOR = [
  'PortInRequestAccepted',
  'PortInRequestScheduled',
  'PortInRequestReadyToBeScheduledResponseExpired',
  'PortInRequestSchedulingConfirmedResponseExpired',
  'PortInRequestScheduledFailed',
  'PortInRequestSchedulingConfirmed',
  'PortInRequested',
  'OK',
];
